import {NgModule} from '@angular/core';
import {ChannelConfigPage} from "./page/overview/channel-config/channel-config.page";
import {CoOverviewPage} from "./page/co-overview-page/co-overview.page";
import {CoKpiComponent} from "./page/co-overview-page/components/kpiComponent/co-kpi.component";
import {CoStatisticsComponent} from "./page/co-overview-page/components/statisticsComponent/co-statistics.component";
import {CO_ENTITY_PROVIDER} from "./co.entity-provider";
import {CoreModule} from "../../core/core.module";
import {UiModule} from "../../core/ui/ui.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {CO_TEST_PROVIDERS} from "./test/co-test-definition";

@NgModule({
    declarations: [
        ChannelConfigPage,
        CoOverviewPage,
        CoKpiComponent,
        CoStatisticsComponent
    ],
    exports: [
        ChannelConfigPage,
    ],
    imports: [
        CoreModule,
        UiModule
    ],
    providers: [CO_ENTITY_PROVIDER, CO_TEST_PROVIDERS]
})
export class CoModule implements DynamicModule {

    alias = 'co';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return CoKpiComponent;
    }

    getStatisticsComponent() {
        return CoStatisticsComponent;
    }
}


